module.exports = ".contact_style3{\r\n    min-height: 250px;\r\n}"